import { IServiceLocator } from '~/services';

/**
 * The very basic concept of "component".
 * Created as a transitional code from the current AM website inline vanilla JS
 * to some real UI rendering library as React + TS,
 * because there is still no decision about the future frontend stack
 */
export default class AbstractComponent<P = any> implements IAmComponent<P> {

    public constructor(
        protected element: HTMLElement,
        protected attribute: string,
        protected locator: IServiceLocator
    ) {}

    public get defaultParams(): P {
        return (<any>this).constructor.defaultParams || {};
    }

    /**
     * Triggers component update
     */
    public update() {
        const that = <AbstractComponent & IAmComponent>this;
        that.onUpdate && that.onUpdate();
    }

    /**
     * Gets live params
     *
     * @protected
     */
    protected get params(): P {
        const { element, attribute } = this;
        const value = element.getAttribute(attribute);
        let def = this.defaultParams;

        try {
            const parsed = JSON.parse(value || 'null');
            return parsed !== null ? {...def, ...parsed} : def;
        } catch (e) {
            console && console.error(
                'Failed to parse [%s] params of %O \n %s', attribute, element, e,
            );
        }

        return def;
    }
}

export interface IAmComponentClass<P = any> {
    new (
        // matched element
        element: HTMLElement,

        // attribute used to match
        attribute: string,

        // service locator
        locator: IServiceLocator
    ): IAmComponent<P>;
}

export interface IAmComponent<P = any> {

    // default parameters when no parameters supplied in the attribute
    defaultParams: P;

    // triggers component update
    update: () => void;

    // fires on component mount
    onMount?: () => void;

    // fires on component update
    onUpdate?: () => void;
}
